import ButtonStyle from "../style/button.component";
import DivStyle from "../style/div.component";
import FormInputDash from "./form_input_dash";
import {
  FormProps,
  FormTempInterface,
  FormTypeProps,
} from "./interface/formInterface";

const FormTemp = (props: FormTempInterface) => {
  const { data } = props;
  const { value, label, setValue, width, type } = data;
  switch (type) {
    case "input-dash":
      return (
        <FormInputDash
          height="20px"
          fontSize="13px"
          value={value}
          label={label}
          setValue={setValue}
          width={width}
        ></FormInputDash>
      );
  }
  return null;
};
const ReferralForm = (props: FormProps) => {
  const { form, title, add, mode, save } = props;
  return (
    <DivStyle
      backgroundColor="#1E1E1E"
      width="100%"
      height="calc(auto + 10px)"
      display="flex"
      flex_direction="column"
      align_items="center"
    >
      <span
        style={{
          width: "100%",
          textAlign: "center",
          fontSize: "18px",
          color: "#FFFFFFB3",
          marginTop: "30px",
        }}
      >
        {title}
      </span>
      {form.map((item: FormTypeProps, index: number) => (
        <div key={index} style={{ width: "90%", marginBottom: "20px" }}>
          <FormTemp data={item}></FormTemp>
          <DivStyle
            width="100%"
            marginTop="20px"
            display="flex"
            align_items="center"
            justify_content="center"
          >
            {item.label === "성별" && mode === "U" && (
              <ButtonStyle
                onClick={() => add()}
                width="100px"
                height="40px"
                border="none"
                backgroundColor="#1976D2"
                borderRadius="5px"
                color="white"
              >
                레퍼럴 생성
              </ButtonStyle>
            )}
          </DivStyle>
        </div>
      ))}
      {mode === "U" ? (
        <div>
          <ButtonStyle
            onClick={() => save()}
            marginBottom="30px"
            width="70px"
            height="40px"
            border="none"
            backgroundColor="#1976D2"
            borderRadius="5px"
            color="white"
          >
            복사
          </ButtonStyle>
        </div>
      ) : null}
    </DivStyle>
  );
};

export default ReferralForm;
